<!-- Lists container -->
<div class="flex flex-row w-9/12 p-6">
    <!-- Left list (available) -->
    <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
        <!-- Title -->
        <div class="flex text-lg font-medium tracking-tight truncate mb-2">
            {{ 'availableFields' | transloco }}
        </div>

        <!-- List -->
        <mat-list class="select-none">
            @for (field of selectorItems.notAddedItems; track $index) {
                <mat-list-item class="mt-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-md font-medium tracking-tight cursor-pointer"
                    [ngClass]="field.state.selected ? 'bg-gray-200 dark:bg-gray-600' : ''" (click)="select($event, field)">
                    {{ field.id }}
                </mat-list-item>
            }
        </mat-list>
    </div>

    <!-- arrow buttons -->
    <div class="flex flex-col mx-10 justify-center">
        <!-- right -->
        <button mat-icon-button (click)="moveTo('added')"
            [disabled]="!(selectorItems.selectedColumn === 'available') || readonly">
            <mat-icon svgIcon="heroicons_outline:arrow-right" class="icon-size-8"></mat-icon>
        </button>

        <!-- left -->
        <button mat-icon-button (click)="moveTo('available')"
            [disabled]="!(selectorItems.selectedColumn === 'added') || readonly">
            <mat-icon svgIcon="heroicons_outline:arrow-left" class="icon-size-8"></mat-icon>
        </button>
    </div>

    <!-- Right list (added) -->
    <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden" cdkDropList
        [cdkDropListDisabled]="readonly" [cdkDropListData]="selectorItems.addedItems"
        (cdkDropListDropped)="drop($event)" cdkDropListLockAxis="y">
        <!-- Title -->
        <div class="flex text-lg font-medium tracking-tight truncate mb-2">
            {{ 'addedFields' | transloco }}
        </div>

        <!-- List -->
        <mat-list class="select-none">
            @for (field of selectorItems.addedItems; track $index) {
                <mat-list-item class="mt-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg text-md font-medium tracking-tight"
                    [class.cursor-move]="!readonly" [ngClass]="field.state.selected ? 'bg-gray-200 dark:bg-gray-600' : ''"
                    (click)="select($event, field)" cdkDrag [cdkDragData]="field">
                    <!-- TODO Drag preview -->
                    <div class="flex flex-0 w-0 h-0" *cdkDragPreview></div>
                    {{ field.id }}
                </mat-list-item>
            }
        </mat-list>
    </div>
</div>